<div class="row">
  <div class="col-xs-12">
    <form (ngSubmit)="onSubmit(f)" #f="ngForm">
      <div class="row">

        <div class="col-sm-5 form-group">
          <label for="name">Name</label>
          <input
            type="text"
            id="name"
            class="form-control"
            name="name"
            ngModel
            required
          >
        </div>

        <div class="col-sm-5 form-group">
        <label for="text">Text</label>
          <input
            type="text"
            id="text"
            class="form-control"
            name="text"
            ngModel
            required
          >
        </div>

        <div class="col-sm-2 form-group">
          <label for="type">Type</label>
                <br>
                <select
                id="type"
                class="form-control"
                name="type" ngModel>
                <option value="audio" selected>Audio Recording</option>
                <option value="star5">5 Star Rating</option>
                <option value="star9">9 Star Rating</option>
                <option value="simpleText">Text Input</option>
                <option value="info">Information</option>
              </select>
        </div>
      
      </div>
      
      <div class="row">
        <div class="col-xs-12">
          <button
            class="btn btn-success"
            type="submit"
            [disabled]="!f.valid">{{ editMode ? 'Update' : 'Add' }}</button>
          <button
            class="btn btn-danger"
            type="button"
            (click)="onDelete()"
            *ngIf="editMode">Delete</button>
          <button class="btn btn-primary" type="button" (click)="onClear()">Clear</button>
        </div>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/question-list/question-edit/question-edit.component.html